import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchLocation = createAsyncThunk(
  "location/fetchLocation",
  async ({ lat, lon }) => {
    // Call backend endpoint that handles geocoding with proper User-Agent header
    const baseURL =
      process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";
    const response = await axios.get(
      `${baseURL}/api/location/reverse-geocode`,
      {
        params: { lat, lon },
      },
    );

    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to fetch location");
    }

    return response.data.data;
  },
);

const locationSlice = createSlice({
  name: "location",
  initialState: {
    city: "",
    country: "",
    status: "idle",
    error: null,
  },
  reducers: {
    // ADD THIS: Manual update for instant UI reflection
    updateLocation(state, action) {
      state.city = action.payload.city;
      state.country = action.payload.country;
      state.latitude = action.payload.latitude;
      state.longitude = action.payload.longitude;
      state.status = "succeeded";
      state.error = "";
    },
    clearLocation(state) {
      state.city = "";
      state.country = "";
      state.latitude = null;
      state.longitude = null;
      state.status = "idle";
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLocation.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.city = action.payload.city;
        state.country = action.payload.country;
        state.error = "";
      })
      .addCase(fetchLocation.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { clearLocation, updateLocation } = locationSlice.actions;
export default locationSlice.reducer;
